/** Public continuity-realization sequence (hub → threads → horizon). */
export type PrimerThreadStep = {
  id: string;
  title: string;
  href: string;
  external?: boolean;
  phase: string;
};

export const PRIMER_CONTINUITY_SEQUENCE: readonly PrimerThreadStep[] = [
  {
    id: "cross-post",
    title: "Canonical Cross Post",
    href: "/cross-post",
    phase: "Signal",
  },
  {
    id: "why-systems-fail",
    title: "Why Systems Fail",
    href: "/primer/why-systems-fail",
    phase: "Signal",
  },
  {
    id: "continuity-surfaces",
    title: "Continuity Surfaces",
    href: "/primer/continuity-surfaces",
    phase: "Represent",
  },
  {
    id: "vault-verification",
    title: "Inspect Continuity",
    href: "https://verify.xo-vault.com/vault/verify.html?traverse=1&source=cross-post",
    external: true,
    phase: "Inspection",
  },
  {
    id: "continuity-replay",
    title: "Replay Continuity",
    href: "/continuity-replay?source=cross-post",
    phase: "Replay",
  },
  {
    id: "message-bottle",
    title: "Message Bottle",
    href: "/message-bottle",
    phase: "Symbol",
  },
  {
    id: "call-demo",
    title: "XO Call (background)",
    href: "/call?demo=1",
    phase: "Replay",
  },
  {
    id: "trust-continuum",
    title: "Trust Continuum",
    href: "/primer/trust-continuum",
    phase: "Witness",
  },
  {
    id: "defense-layer",
    title: "Defense Layer",
    href: "/primer/defense-layer",
    phase: "Horizon",
  },
  {
    id: "horizon",
    title: "Horizon",
    href: "/horizon",
    phase: "Future implications",
  },
] as const;

export function getPrimerThreadIndex(id: string): number {
  return PRIMER_CONTINUITY_SEQUENCE.findIndex((s) => s.id === id);
}

export function getNextPrimerThread(id: string): PrimerThreadStep | null {
  const i = getPrimerThreadIndex(id);
  if (i < 0 || i >= PRIMER_CONTINUITY_SEQUENCE.length - 1) return null;
  return PRIMER_CONTINUITY_SEQUENCE[i + 1] ?? null;
}

export function getPrevPrimerThread(id: string): PrimerThreadStep | null {
  const i = getPrimerThreadIndex(id);
  if (i <= 0) return null;
  return PRIMER_CONTINUITY_SEQUENCE[i - 1] ?? null;
}
